// src/pages/ApplyCarryForwardLeave.js
import React, { useEffect, useState } from "react";
import apiClient from "../utils/apiClient";
import SessionHandler from "../components/SessionHandler";
import "./ApplyCarryForwardLeave.css";

const ApplyCarryForwardLeave = () => {
  const today = new Date().toISOString().split("T")[0];

  const [form, setForm] = useState({
    start_date: "",
    end_date: "",
    reason: "",
  });

  const [summary, setSummary] = useState(null);
  const [days, setDays] = useState(0);
  const [loading, setLoading] = useState(false);

  // Modal
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [modalType, setModalType] = useState("success");

  /* ================= FETCH CF SUMMARY ================= */
  useEffect(() => {
    fetchSummary();
  }, []);

  const fetchSummary = async () => {
    const data = await apiClient("/cfleaves/self/");
    if (data?.summary) setSummary(data.summary);
  };

  /* ================= DATE CHANGE ================= */
  useEffect(() => {
    if (form.start_date && form.end_date) {
      const start = new Date(form.start_date);
      const end = new Date(form.end_date);

      if (end >= start) {
        const diff =
          Math.ceil((end - start) / (1000 * 60 * 60 * 24)) + 1;
        setDays(diff);
      } else {
        setDays(0);
      }
    } else {
      setDays(0);
    }
  }, [form.start_date, form.end_date]);

  /* ================= SUBMIT ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.start_date || !form.end_date) {
      setModalType("error");
      setModalMessage("Please select both start and end dates");
      setShowModal(true);
      return;
    }

    if (days > summary.remaining) {
      setModalType("error");
      setModalMessage("Applied days exceed remaining Carry Forward leave");
      setShowModal(true);
      return;
    }

    try {
      setLoading(true);

   await apiClient("/cfleaves/apply/", {
  method: "POST",
  body: JSON.stringify({
    start_date: form.start_date,
    end_date: form.end_date,
    reason: form.reason,
  }),
});


      setModalType("success");
      setModalMessage("Carry Forward Leave applied successfully");
      setShowModal(true);

      setForm({ start_date: "", end_date: "", reason: "" });
      setDays(0);
      fetchSummary();
    } catch (err) {
      setModalType("error");
      setModalMessage("Failed to apply Carry Forward Leave");
      setShowModal(true);
    } finally {
      setLoading(false);
    }
  };

  if (!summary) return <p>Loading...</p>;

  return (
    <div className="cf-apply-container">
      <h2>Apply Carry Forward Leave</h2>

      {/* SUMMARY */}
      <div className="cf-balance">
        Remaining Carry Forward Leave:
        <span>{summary.remaining}</span>
      </div>

      {/* FORM */}
      <form onSubmit={handleSubmit} className="cf-form">
        
        {/* DATE ROW */}
        <div className="form-row">
          <div className="form-group">
            <label>From</label>
            <input
              type="date"
              required
              min={today}                  // ✅ start from today
              value={form.start_date}
              onChange={(e) =>
                setForm({
                  ...form,
                  start_date: e.target.value,
                  end_date: "", // reset end date if start changes
                })
              }
            />
          </div>

          <div className="form-group">
            <label>To</label>
            <input
              type="date"
              required
              min={form.start_date || today}  // ✅ must be after start date
              value={form.end_date}
              onChange={(e) =>
                setForm({ ...form, end_date: e.target.value })
              }
              disabled={!form.start_date}
            />
          </div>

          <div className="form-group days">
            <label>Days</label>
            <input type="number" value={days} disabled />
          </div>
        </div>

        <div className="form-group">
          <label>Reason</label>
          <textarea
            required
            value={form.reason}
            onChange={(e) =>
              setForm({ ...form, reason: e.target.value })
            }
          />
        </div>

        <div className="actions">
          <button
            type="submit"
            disabled={loading || summary.remaining === 0}
          >
            {loading ? "Applying..." : "Apply"}
          </button>

          <button
            type="button"
            className="cancel"
            onClick={() => window.history.back()}
          >
            Cancel
          </button>
        </div>
      </form>

      {/* MODAL */}
      {showModal && (
        <div className="modal-overlay">
          <div className={`modal-box ${modalType}`}>
            <h3>{modalType === "success" ? "Success" : "Error"}</h3>
            <p>{modalMessage}</p>
            <button onClick={() => setShowModal(false)}>OK</button>
          </div>
        </div>
      )}

      <SessionHandler />
    </div>
  );
};

export default ApplyCarryForwardLeave;
